import {Pipe, PipeTransform} from '@angular/core';
import StoreProduct from '../../_entities/products/store-product.entity';
import {StatesHelper} from '../../states/states.helper';

@Pipe( {
    name: 'storeProductById',
    pure: true
})
export class StoreProductByIdPipe implements PipeTransform {
    transform(productId: number, storeId: number): StoreProduct {
        const storeProduct = StatesHelper.storeProductsEntitiesState.entities[`${productId}_${storeId}`];
        if (storeProduct) return;
        return new StoreProduct(storeProduct);
    }
}
